(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-universe-feed"] && !Shopify.designMode) return;
  try {
    (() => {
  const cache = new Map();
  const safeURL = (raw) => { try { const u = new URL(raw, location.origin); return ['https:','http:'].includes(u.protocol) ? u : null; } catch { return null; } };
  const eligible = (a, world) => a.tags.includes(world) && a.tags.includes('universe_approved') && !a.tags.includes('universe_exclude') && (a.tags.includes('universe_evergreen') || (a.expires && Date.parse(a.expires) > Date.now())) && !a.tags.some(t => t.toLowerCase().includes('insider'));
  const rank = (items,topics) => items.map((a,i)=>({a,i,score:topics.reduce((s,t)=>s+(a.tags.includes(t)?(t.startsWith('subject_')?100:10):0),0)})).sort((a,b)=>b.score-a.score || Date.parse(b.a.date)-Date.parse(a.a.date) || a.i-b.i).map(x=>x.a);
  // Keep the strongest relevant recent choices and reserve one place for lasting value.
  const select = (items,topics,limit) => {
    const ranked=rank(items,topics), count=Math.max(1,Math.min(6,Number(limit)||3));
    const chosen=ranked.slice(0,Math.max(0,count-1));
    const rest=ranked.filter(a=>!chosen.includes(a));
    const lasting=rest.find(a=>a.tags.includes('universe_featured') && a.tags.includes('universe_evergreen')) || rest.find(a=>a.tags.includes('universe_evergreen')) || rest[0];
    if(lasting) chosen.push(lasting);
    return chosen;
  };
  async function getItems(path) {
    if (cache.has(path)) return cache.get(path);
    const promise=(async()=>{
      let next=new URL(path,location.origin), results=[],seen=new Set();
      for(let page=0;next && page<20;page++) {
        if(next.origin!==location.origin || seen.has(next.href)) throw Error('Invalid feed page');
        seen.add(next.href);
        const response=await fetch(next.href,{credentials:'same-origin'});
        if(!response.ok) throw Error('Discovery unavailable');
        const data=JSON.parse(await response.text());
        if(!Array.isArray(data.items)) throw Error('Invalid discovery data');
        results.push(...data.items);
        next=data.next?new URL(data.next,location.origin):null;
        if(next) next.searchParams.set('view','ga-universe-feed');
      }
      return results;
    })();cache.set(path,promise);return promise;
  }
  async function renderFeed(el) {
    if(el.dataset.loaded) return;el.dataset.loaded='true';
    try {
      const topics=(el.dataset.topics||'').split(',').filter(Boolean);
      const used=new Set();
      const candidates=(await getItems(el.dataset.feedUrl)).filter(a=>eligible(a,el.dataset.world)).filter(a=>{
        const url=safeURL(a.url);if(!url || url.origin!==location.origin || url.pathname===location.pathname || used.has(url.pathname)) return false;used.add(url.pathname);return true;
      });
      const items=select(candidates,topics,el.dataset.limit);
      for(const a of items) {
        const link=document.createElement('a');link.className='u-card';link.href=a.url;link.dataset.universeClick='story';link.dataset.contentId=a.id;link.dataset.placement=el.dataset.placement;
        if(a.image && safeURL(a.image)) {const img=document.createElement('img');img.src=a.image;img.alt='';img.width=600;img.height=375;img.loading='lazy';link.append(img);}
        const copy=document.createElement('div');copy.className='u-card-copy';
        const type=document.createElement('p');type.className='u-kicker';type.textContent=a.tags.includes('format_interview')?el.dataset.interviewLabel:el.dataset.featureLabel;
        const title=document.createElement('h3');title.textContent=a.title;
        const text=document.createElement('p');text.textContent=a.excerpt;
        const cta=document.createElement('span');cta.className='u-link';cta.textContent=el.dataset.readLabel+' →';
        copy.append(type,title,text,cta);link.append(copy);el.append(link);
      }
      if(!items.length) {const optional=el.closest('[data-universe-optional]');if(optional) optional.hidden=true;}
    } catch {const optional=el.closest('[data-universe-optional]');if(optional) optional.hidden=true;}
  }
  const start=()=>document.querySelectorAll('[data-universe-feed]').forEach(el=>{
    if(!('IntersectionObserver' in window)) return renderFeed(el);
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();renderFeed(el);}},{rootMargin:'500px'});observer.observe(el);
  });
  start();document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-universe-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.ga-nav details[open]').forEach(el=>el.removeAttribute('open'));});
document.addEventListener('click',event=>{document.querySelectorAll('.ga-nav').forEach(nav=>{if(!nav.contains(event.target))nav.querySelectorAll('details[open]').forEach(el=>el.removeAttribute('open'));});});
  } catch(e) { console.error(e); }
})();

})();
